export const COMPANIES = {
  cropIn: "cropIn",
  cdFinance: "CD finance",
  sunseap: "sunseap",
  kimDental: "kim dental",
  v2Food: "v2 food",
}
